const localeMap = {
  en: 'a5ac163e-67f5-4464-aad1-faac2d05dbea',
  de: '7ce2909c-477b-11e6-b906-1712142eaacb',
  jp: '6e926cec-477b-11e6-b906-1712142eaacb',
};

const getDefaultState = () => ({
  locale: 'en',
  siteID: localeMap['en'],
});

const config = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setLocale(state, locale) {
      state.locale = locale || 'en';
    },
  },
  actions: {
    changeLocale({ commit }, locale: string) {
      commit('setLocale', locale);
    },
  },
};

export default config;
